import { IGame } from "../entities/games";

export const gamesMiddleware = async (games: IGame[]): Promise<IGame[]> => {

  const doesImageExist = (url: string): Promise<boolean> => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;
      img.onload = () => resolve(true);   // Картинка существует
      img.onerror = () => resolve(false); // Картинка не найдена или не загружается
    });
  }

  const updatedGames = await Promise.all(
    games.map(async (item) => {
      const imageUrl = `../Images/logos/${item.systemName}.png`;
      const exists = await doesImageExist(imageUrl);
      if (exists) {
        return {
          ...item,
          image: imageUrl,
        };
      } else {
        return {
          ...item,
        };
      }
    })
  );

  return updatedGames;
};
